module.exports = __webpack_public_path__ + "img/product_banner_06.e986d9df.jpg";